import DOMPurify from 'dompurify'

export const sanitizar = (valor) => DOMPurify.sanitize(valor)
